export var TipoProprietarioEnum;
(function (TipoProprietarioEnum) {
    TipoProprietarioEnum["PROPRIETARIO"] = "PROPRIETARIO";
    TipoProprietarioEnum["COPROPRIETARIO"] = "COPROPRIETARIO";
    TipoProprietarioEnum["CONDOMINO"] = "CONDOMINO";
    TipoProprietarioEnum["ADMINISTRADOR_ESPOLIO"] = "ADMINISTRADOR_ESPOLIO";
    TipoProprietarioEnum["POSSEIRO"] = "POSSEIRO";
    TipoProprietarioEnum["ARRENDATARIO"] = "ARRENDATARIO";
    TipoProprietarioEnum["COMODATARIO"] = "COMODATARIO";
    TipoProprietarioEnum["PARCEIRO_IMOVEL"] = "PARCEIRO_IMOVEL";
    TipoProprietarioEnum["ORGAO_PUBLICO_MUNI_EST"] = "ORGAO_PUBLICO_MUNI_EST";
})(TipoProprietarioEnum || (TipoProprietarioEnum = {}));
(function (TipoProprietarioEnum) {
    var mapDescricao = new Map([
        [TipoProprietarioEnum.PROPRIETARIO, 'Proprietário'],
        [TipoProprietarioEnum.COPROPRIETARIO, 'Coproprietário'],
        [TipoProprietarioEnum.CONDOMINO, 'Condômino'],
        [TipoProprietarioEnum.ADMINISTRADOR_ESPOLIO, 'Administrador do Espólio'],
        [TipoProprietarioEnum.POSSEIRO, 'Posseiro'],
        [TipoProprietarioEnum.ARRENDATARIO, 'Arrendatário'],
        [TipoProprietarioEnum.COMODATARIO, 'Comodatário'],
        [TipoProprietarioEnum.PARCEIRO_IMOVEL, 'Parceiro do Imóvel'],
        [TipoProprietarioEnum.ORGAO_PUBLICO_MUNI_EST, 'Órgão Público Municipal/Estadual'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    TipoProprietarioEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    TipoProprietarioEnum.getOptions = getOptions;
})(TipoProprietarioEnum || (TipoProprietarioEnum = {}));
